import React from "react";

const MainCard = ({ children, className = "", bodyClassName = "" }) => {
  return (
    <div className={`card bg-white shadow-xl mx-auto ${className}`}>
      <div className={`card-body min-h-[800px] ${bodyClassName}`}>
        {children}
      </div>
    </div>
  );
};

export default MainCard;
